export default "__VITE_ASSET__QSODJGu4__"